/* Zubo theme JS — v2 with cart drawer */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(n) { return '$' + Number(n || 0).toFixed(2); }

  /* ===== CART DRAWER ===== */
  var drawer = $('[data-cart-drawer]');
  var itemsEl = drawer && $('[data-drawer-items]', drawer);
  var freeEl = drawer && $('[data-free-ship]', drawer);
  var freeMsg = drawer && $('[data-free-msg]', drawer);
  var freePct = drawer && $('[data-free-pct]', drawer);
  var totalEl = drawer && $('[data-cart-total]', drawer);
  var footEl = drawer && $('[data-drawer-foot]', drawer);
  var countEl = $('[data-cart-count]');
  var THRESHOLD = drawer ? parseInt(drawer.getAttribute('data-threshold') || '4000', 10) : 4000;

  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('z-no-scroll'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('z-no-scroll'); } }
  if (drawer) {
    $$('[data-drawer-close]', document).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function renderCart(cart) {
    if (!cart) return;
    var empty = (!cart.item_count || cart.item_count === 0);
    if (empty) {
      itemsEl.innerHTML = '<p class="z-drawer-empty">Your cart is empty. Go grab something for your pup 🐾</p>';
      if (footEl) footEl.style.display = 'none';
      if (freeEl) freeEl.style.display = 'none';
    } else {
      if (footEl) footEl.style.display = '';
      var rows = cart.items.map(function (it) {
        var img = it.featured_image && it.featured_image.url
          ? '<img src="' + it.featured_image.url.replace(/[?&]width=\d+/, '?width=160') + '" alt="">'
          : '<div class="z-drawer-ph"></div>';
        return '<div class="z-drawer-item">'
          + img
          + '<div class="z-drawer-it"><div class="t">' + it.product_title + '</div>'
          + '<div class="v">' + (it.variant_title || '') + ' · ×' + it.quantity + '</div>'
          + '<button type="button" class="z-remove" data-remove="' + it.key + '">Remove</button></div>'
          + '<div class="p">' + money(it.final_line_price / 100) + '</div>'
          + '</div>';
      }).join('');
      itemsEl.innerHTML = rows;
      $$('[data-remove]', itemsEl).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var fd = new FormData(); fd.append('updates[' + btn.getAttribute('data-remove') + ']', '0');
          fetch('/cart/update.js', { method: 'POST', body: fd })
            .then(function (r) { return r.json(); }).then(renderCart).catch(function () { location.href = '/cart'; });
        });
      });
      // free shipping bar
      var totalCents = cart.items_subtotal_price || 0;
      if (totalEl) totalEl.textContent = money(totalCents / 100);
      if (freeEl) {
        freeEl.style.display = '';
        if (totalCents >= THRESHOLD) {
          freeMsg.innerHTML = '🎉 <b>Free shipping unlocked!</b>';
          freePct.style.width = '100%';
        } else {
          freeMsg.innerHTML = '🚚 You\u2019re <b>' + money((THRESHOLD - totalCents) / 100) + '</b> away from free shipping';
          freePct.style.width = Math.min(100, Math.round(totalCents / THRESHOLD * 100)) + '%';
        }
      }
    }
    if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count ? '' : 'none'; }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(renderCart).catch(function () {});
  }

  /* AJAX add-to-cart for every cart/add form (PDP, bundles, sticky, final CTA) */
  function ajaxAdd(form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.disabled) return;
      if (btn) { btn.disabled = true; }
      var data = form.getAttribute('data-add-extra') ? form.getAttribute('data-add-extra') : '{}';
      var fd = new FormData(form);
      try { fd.append('sections', 'cart-drawer'); } catch (e) {}
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          var id = fd.get('id') || '';
          document.dispatchEvent(new CustomEvent('zubo:added', {
            detail: { id: id, title: document.title.split('–')[0].trim(), price: 0, category: 'uncategorized' }
          }));
          return refreshCart();
        })
        .then(function () { if (btn) btn.disabled = false; openDrawer(); })
        .catch(function () {
          if (btn) btn.disabled = false;
          form.submit(); // fallback to normal add (navigates to cart)
        });
    });
  }
  $$('form[action*="/cart/add"]').forEach(ajaxAdd);

  /* header cart link opens drawer */
  var cartLinks = $$('a[href*="/cart"]');
  cartLinks.forEach(function (a) {
    if (a.getAttribute('href').indexOf('cart/add') !== -1) return;
    a.addEventListener('click', function (ev) {
      if (drawer && drawer.getAttribute('aria-hidden') === 'true') { ev.preventDefault(); openDrawer(); }
    });
  });

  /* lazy: set pwets for checkout clicks already global in theme.liquid */

  /* ===== NAV ===== */
  var burger = $('.z-burger');
  var nav = $('.z-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.add('is-open'); });
    $$('a', nav).forEach(function (a) { a.addEventListener('click', function () { nav.classList.remove('is-open'); }); });
    $('.z-nav-close').addEventListener('click', function () { nav.classList.remove('is-open'); });
  }

  /* ===== GALLERY ===== */
  var thumbs = $$('.z-gallery-thumbs button');
  var main = $('.z-gallery-main img');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) main.src = btn.getAttribute('data-src');
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ===== OPTIONS -> variant id sync ===== */
  var productJson = $('#z-product-json');
  var variantForm = $('#z-variant-form');
  function setVariant() {
    if (!variantForm || !productJson) return;
    var p = JSON.parse(productJson.textContent);
    var chosen = {};
    $$('.z-option-select', variantForm).forEach(function (sel) { chosen[sel.getAttribute('data-option')] = sel.value; });
    var v = p.variants.filter(function (vv) {
      return vv.options.every(function (o, i) { return o === p.options[i].values.indexOf(chosen[p.options[i].name]) !== -1 || o === chosen[p.options[i].name]; });
    })[0];
    // simpler match by options array equality
    var names = p.options.map(function (o) { return o.name; });
    v = p.variants.filter(function (vv) {
      return names.every(function (n, i) { return vv.options[i] === chosen[n]; });
    })[0];
    if (!v) return;
    $$('form[action*="/cart/add"] input[name="id"]').forEach(function (inp) { inp.value = v.id; });
    $$('.z-price-row .now').forEach(function (el) { el.textContent = money(v.price); });
    var was = $$('.z-price-row .was')[0], save = $$('.z-price-row .save')[0];
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (was) was.textContent = money(v.compare_at_price);
      if (save) { var pct = Math.round((1 - v.price / v.compare_at_price) * 100); save.textContent = pct + '% OFF'; }
    }
  }
  if (variantForm) {
    $$('.z-option-select', variantForm).forEach(function (sel) { sel.addEventListener('change', setVariant); });
    setVariant();
  }

  /* ===== BUNDLES ===== */
  var bundles = $$('.z-bundle input[type="radio"]');
  bundles.forEach(function (r) {
    r.addEventListener('change', function () {
      var qty = parseInt(r.getAttribute('data-qty'), 10) || 1;
      $$('.z-qty-field').forEach(function (f) { f.value = qty; });
      $$('.z-bundle').forEach(function (b) { b.classList.remove('is-active'); });
      r.closest('.z-bundle').classList.add('is-active');
    });
  });

  /* ===== STICKY BAR ===== */
  var sticky = $('.z-sticky');
  if (sticky) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var nearBottom = window.innerHeight + y > document.body.scrollHeight - 460;
      sticky.classList.toggle('is-visible', y > 700 && !nearBottom);
    }, { passive: true });
  }

  /* init cart count on load */
  refreshCart();

  /* expose for theme.liquid */
  window.zuboCart = { open: openDrawer, refresh: refreshCart };
})();